<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <div class="d-flex">
              <strong class="align-self-center"
                >Projeto: {{ viewModel.projectName }}</strong
              >
              <download-csv
                title="Baixar dados planilha"
                v-if="viewModel.itens && viewModel.itens.length > 0"
                class="ml-auto no-print"
                :data="GetCsv()"
                :separator-excel="false"
                :name="viewModel.projectName + '.csv'"
              >
                <button class="btn"><i class="fas fa-file-excel"></i></button>
              </download-csv>
            </div>
          </header>
          <div v-if="loading" class="loading-container">
            <RotateSquare
              class="loading-position animated fadeIn"
              size="60px"
            ></RotateSquare>
          </div>
          <div v-else class="card-body">
            <GoogleMaps :markers="markers" />

            <b-table
              :hover="true"
              responsive
              :items="viewModel.itens"
              :fields="fields"
              select-mode="single"
              selectable
              striped
              show-empty
              empty-text="Nenhum inventário encontrado."
              @row-selected="OnRowSelected"
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:cell(date)="data">
                <span>{{ FormatDate(data.item.date) }}</span>
              </template>
            </b-table>

            <div
              class="row"
              v-if="viewModel.itens && viewModel.itens.length > 0"
            >
              <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5">
                <div class="form-group">
                  <label for>Atualizar</label>
                  <b-form-file
                    v-model="file"
                    :state="Boolean(file)"
                    placeholder="Planilha..."
                    accept=".csv"
                    browse-text="Procurar"
                  ></b-form-file>
                </div>
              </div>
            </div>
            <div class="btn-group" role="group">
              <button
                class="btn btn-secondary"
                type="reset"
                @click="$router.go(-1)"
              >
                Voltar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../../components/RotateSquare";
import InventoryService from "../../../servico/InventoryService";
import ProjectService from "../../../servico/ProjectService";
import DateTime from "../../../util/DateTime";
import Format from "../../../util/Format";
import GoogleMaps from "../../../components/GoogleMaps";

export default {
  name: "TableInvetory",
  components: {
    RotateSquare,
    DateTime,
    GoogleMaps
  },
  data() {
    return {
      loading: false,
      file: null,
      markers: [],
      viewModel: {
        itens: [],
        projectName: "",
        projectId: ""
      },
      fields: [
        { key: "sequence", label: "Id", sortable: true },
        { key: "date", label: "Data", sortable: true },
        { key: "commonName", label: "Nome Comum", sortable: true },
        { key: "scientificName", label: "Nome Científico", sortable: true },
        { key: "origin", label: "Origem", sortable: true },
        { key: "family", label: "Família", sortable: true },
        { key: "heigth", label: "Altura", sortable: true },
        { key: "heigthClass", label: "Classe Altura", sortable: true },
        { key: "cap", label: "CAP", sortable: true },
        { key: "dap", label: "DAP", sortable: true },
        { key: "userName", label: "Usuário", sortable: true }
      ]
    };
  },
  watch: {
    file: function (val) {
      if (!val) return;

      this.loading = true;
      ProjectService.ReportTableUpdate(this.viewModel.projectId, val)
        .then((response) => {
          this.loading = false;
          this.file = null;
          this.GetGrid(this.viewModel.projectId);
        })
        .catch((erro) => {
          this.loading = false;
          this.file = null;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    }
  },
  beforeMount() {
    let id = this.$route.params.projectId;
    this.GetGrid(id);
    this.GetMarkers(id);
  },
  methods: {
    GetMarkers(projectId) {
      ProjectService.GetCoordinates(projectId)
        .then((result) => {
          this.markers = result.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    GetCsv() {
      if (!this.viewModel.itens) return [];
      return this.viewModel.itens.map((elem) => {
        let data = this.FormatDate(elem.date);
        let cap = Format.Number(elem.cap);
        let dap = Format.Number(elem.dap);
        return {
          Id: elem.sequence,
          Data: data,
          NomeComum: elem.commonName,
          NomeCientifico: elem.scientificName,
          Origem: elem.origin,
          Familia: elem.family,
          Altura: elem.heigth,
          ClasseAltura: elem.heigthClass,
          CAP: cap,
          DAP: dap,
          Latitude: elem.latitude,
          Longitude: elem.longitude,
          Observacao: elem.obs,
          Usuario: elem.userName,
          Unico: elem.id
        };
      });
    },
    OnRowSelected(item) {
      let url = "/#/inventario/editar/" + item[0].id;
      window.open(url, "_self");
    },
    FormatDate(date) {
      return DateTime.FormatLocale(date);
    },
    GetGrid(projectId) {
      this.loading = true;

      InventoryService.GetReportTable(projectId)
        .then((response) => {
          this.loading = false;
          this.viewModel = response.data;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>
